import { render, staticRenderFns } from "./TaskStatusDisplay.vue?vue&type=template&id=7f993e1a&scoped=true&"
import script from "./TaskStatusDisplay.vue?vue&type=script&lang=js&"
export * from "./TaskStatusDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusDisplay.vue?vue&type=style&index=0&id=7f993e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f993e1a",
  null
  
)

export default component.exports